import { useTranslation } from 'react-i18next';
import { IconAlertTriangle } from '@tabler/icons-react';
import GateBanner from '@/components/common/GateBanner';
import { ROUTES } from '@/routes/paths';

// Ограничение действий по сделке до аттестации: не аттестованный покупатель видит предупреждение вместо
// действий (просмотр остаётся доступен). Вид — общий GateBanner, диплинк в «Моя компания → Аттестация».
export default function AttestationGateBanner() {
  const { t } = useTranslation();
  return (
    <GateBanner
      icon={<IconAlertTriangle size={20} />}
      to={ROUTES.APP_COMPANY_ACCREDITATION}
      title={t('app.deals.attestationGate.title')}
      text={t('app.deals.attestationGate.text')}
      action={t('app.deals.attestationGate.action')}
    />
  );
}
